import React from "react";
import { Box, Typography, InputBase, alpha } from "@mui/material";
import { useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { setSearchQuery } from "../../store/DocumentsSlice";
// import NotificationsIcon from "@mui/icons-material/Notifications";

import Logo from "../../assets/logo/Logo.svg";
import { useLocation } from "react-router-dom";

const DashboardHeader = ({ showSearch = false }) => {
	const companyName = localStorage.getItem("companyName");
	const dispatch = useDispatch();
	const location = useLocation();

	const handleSearchChange = (e) => {
		dispatch(setSearchQuery(e.target.value));
	};

	const showLogo =
		location.pathname === "/get-started" ||
		location.pathname === "/company/deadlines" ||
		location.pathname === "/company/documents";

	return (
		<Box
			sx={{
				backgroundColor: "#110c27",
				width: "100%",
				borderLeft: "1px solid grey",
			}}>
			<Box
				sx={{
					padding: "1rem 0 1rem 1.5rem",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}>
				{showSearch ? (
					<Box
						sx={{
							// width: "100%",
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-start",
							alignItems: "center",
							gap: "1rem",
						}}>
						<Box
							sx={{
								position: "relative",
								borderRadius: "30px",
								backgroundColor: "#FFF",
								"&:hover": {
									backgroundColor: alpha("#f5f5f5", 1),
								},
								marginRight: "auto",
								width: "350px",
							}}>
							<Box
								sx={{
									padding: "0 10px",
									height: "100%",
									position: "absolute",
									pointerEvents: "none",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}>
								<SearchIcon />
							</Box>
							<InputBase
								sx={{
									padding: "8px 8px 8px 40px",
									width: "100%",
								}}
								placeholder='Search'
								onChange={handleSearchChange}
							/>
						</Box>
						{/* <NotificationsIcon sx={{ color: "#FFF" }} /> */}
					</Box>
				) : (
					<Box></Box>
				)}

				{/* {location.pathname === "/get-started" && (
					<NotificationsIcon sx={{ color: "#FFF" }} />
				)} */}

				{!showLogo ? (
					<Box>
						<img src={Logo} alt='Logo' width={"200px"} />
					</Box>
				) : (
					<Box sx={{ marginRight: "1.5rem" }}>
						<Typography
							variant='h6'
							fontWeight='800'
							color='#fff'
							sx={{
								textTransform: "capitalize",
							}}>
							{companyName}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default DashboardHeader;
